import React, { useEffect, useState } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Resolution1552 from './components/Resolution1552/Resolution1552';
import RegistersControl from './components/RegistersControl/RegistersControl';
import ComplaintsAndClaims from './components/ComplaintsAndClaims/ComplaintsAndClaims';
import SatisfactionSurvey from './components/SatisfactionSurvey/SatisfactionSurvey';
import RecomendationSurvey from './components/RecomendationSurvey/RecomendationSurvey';

const QualityIndicators = ({ }) => {

    const [indicatorSelected, setIndicatorSelected] = useState(null);
    const [thirdsList, setThirdsList] = useState([]);

    useEffect(() => {
        getThirdsList();
    }, []);

    const getThirdsList = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error consultando los Terceros');
            }
        }).then(data => {
            setThirdsList(data);
        }).catch((error) => {
            console.log(error);
            setThirdsList([]);
        });
    }

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Indicadores de Calidad</h3>
                </Col>
            </Row>

            <Card>
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <div className="card__title">
                                <h5 className="bold-text">Seleccion de Indicador</h5>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={3}>
                            <TextField
                                id="select_indicator"
                                select
                                label="Indicador"
                                value={indicatorSelected}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setIndicatorSelected(event.target.value);
                                }}

                                style={{ minWidth: '300px', maxWidth: '100%' }}
                            >
                                <MenuItem key={1} value={1}>
                                    Indicador de Resolucion 1552
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    Control de Registros
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    Quejas y Reclamos
                                </MenuItem>
                                <MenuItem key={4} value={4}>
                                    Encuesta de Satisfacción
                                </MenuItem>
                                <MenuItem key={5} value={5}>
                                    Recomendación
                                </MenuItem>
                            </TextField>
                        </Col>
                    </Row>
                    <br />

                    {
                        indicatorSelected == 1 ? <Resolution1552 thirdsList={thirdsList} /> : null
                    }

                    {
                        indicatorSelected == 2 ? <RegistersControl /> : null
                    }

                    {
                        indicatorSelected == 3 ? <ComplaintsAndClaims /> : null
                    }

                    {
                        indicatorSelected == 4 ? <SatisfactionSurvey /> : null
                    }

                    {
                        indicatorSelected == 5 ? <RecomendationSurvey /> : null
                    }

                </CardBody>
            </Card>


        </Container>
    );
}
export default QualityIndicators;